module.exports = __webpack_public_path__ + "static/img/contant_2.0b8c7fe.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1st/Articles/Article_3/contant_2.jpg
// module id = A3r7
// module chunks = 0